import { collection, collectionGroup, doc, getDocs, query, where, orderBy, serverTimestamp, writeBatch } from "firebase/firestore";
import { db } from "../firebase";

const COLLECTION_NAME = "workoutPrescriptions";

/**
 * Busca todas as prescrições do tenant.
 */
export const getAll = async (idTenant) => {
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    try {
        const q = query(
            collectionGroup(db, COLLECTION_NAME),
            where("idTenant", "==", idTenant),
            orderBy("prescribedAt", "desc")
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    } catch (error) {
        console.error("Erro ao listar prescrições:", error);
        throw error;
    }
};

/**
 * Busca prescrições de um aluno específico.
 */
export const getByMember = async (idTenant, idMember) => {
    if (!idTenant || !idMember) throw new Error("Tenant e Member IDs são obrigatórios.");

    try {
        const q = query(
            collection(db, "tenants", idTenant, "members", idMember, COLLECTION_NAME),
            orderBy("prescribedAt", "desc")
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    } catch (error) {
        console.error("Erro ao listar prescrições do aluno:", error);
        throw error;
    }
};

/**
 * Busca prescrições ativas de um aluno específico.
 * Expira silenciosamente prescrições com endDate ultrapassado (fire-and-forget).
 */
export const getActiveByMember = async (idTenant, idMember) => {
    if (!idTenant || !idMember) throw new Error("Tenant e Member IDs são obrigatórios.");

    try {
        const q = query(
            collection(db, "tenants", idTenant, "members", idMember, COLLECTION_NAME),
            where("status", "==", "active")
            // orderBy removido para evitar erro de índice composto ausente no Firestore
        );
        const snapshot = await getDocs(q);

        let results = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

        const today = new Date().toISOString().split("T")[0];
        const active = [];
        const expired = [];

        for (const prescription of results) {
            if (prescription.endDate && prescription.endDate < today) {
                expired.push(prescription);
            } else {
                active.push(prescription);
            }
        }

        if (expired.length > 0) {
            const batch = writeBatch(db);
            for (const exp of expired) {
                const ref = doc(db, "tenants", idTenant, "members", idMember, COLLECTION_NAME, exp.id);
                batch.update(ref, { status: "expired", updatedAt: serverTimestamp() });
            }
            batch.commit().catch(err => console.error("Erro ao expirar prescrições:", err));
        }

        // Ordena localmente para não depender de índice composto
        active.sort((a, b) => {
            const dateA = a.prescribedAt?.toDate ? a.prescribedAt.toDate().getTime() : 0;
            const dateB = b.prescribedAt?.toDate ? b.prescribedAt.toDate().getTime() : 0;
            return dateB - dateA;
        });

        return active;
    } catch (error) {
        console.error("Erro ao listar prescrições ativas do aluno:", error);
        throw error;
    }
};

/**
 * Busca prescrições ativas do tenant inteiro.
 */
export const getActive = async (idTenant) => {
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    try {
        const q = query(
            collectionGroup(db, COLLECTION_NAME),
            where("idTenant", "==", idTenant),
            where("status", "==", "active"),
            orderBy("prescribedAt", "desc")
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    } catch (error) {
        console.error("Erro ao listar prescrições ativas:", error);
        throw error;
    }
};
